import { render, staticRenderFns } from "./LayoutDashboard.vue?vue&type=template&id=1534415b&scoped=true"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js"
import style0 from "./LayoutDashboard.vue?vue&type=style&index=0&id=1534415b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534415b",
  null
  
)

export default component.exports